var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.682,
    height: 19.927,
    viewBox: "0 0 18.682 19.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.359)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M137.906,9.083a.621.621,0,0,0-.567-.365h-2.491V.623A.623.623,0,0,0,134.225,0h-2.491a.623.623,0,0,0-.623.623v8.1h-2.491a.622.622,0,0,0-.468,1.032l4.359,4.982a.621.621,0,0,0,.937,0l4.359-4.982A.621.621,0,0,0,137.906,9.083Z",
    transform: "translate(-127.998)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 13.7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.191,352v3.736h-13.7V352H16v4.982a1.245,1.245,0,0,0,1.245,1.245H33.436a1.244,1.244,0,0,0,1.245-1.245V352Z",
    transform: "translate(-16 -352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDownload);
export default __webpack_public_path__ + "static/media/media-download.5be4b08fda2e83499b3d4074bca4e1a3.svg";
export { ForwardRef as ReactComponent };